import { useEffect } from 'react';
import { useMe } from '@/services/api';
import { useUi, type View } from '@/stores/ui.store';

/**
 * The learner the screens are about and the perspective being shown. Students are always themselves; teachers and
 * parents pick from `me.students`. The first render adopts the API's defaults so nothing flashes empty.
 */
export function useStudent() {
  const me = useMe();
  const { studentId, setStudentId, view, setView } = useUi();
  useEffect(() => {
    if (!me.data) return;
    if (!view || !me.data.views.includes(view)) setView(me.data.default_view as View);
    if (!studentId || !me.data.students.some((s) => s.id === studentId)) setStudentId(me.data.default_student_id);
  }, [me.data, studentId, view, setStudentId, setView]);
  const student = me.data?.students.find((s) => s.id === studentId) ?? me.data?.students[0] ?? null;
  const effectiveView: View = view && me.data?.views.includes(view) ? view : ((me.data?.default_view as View | undefined) ?? 'student');
  return { me: me.data, student, studentId: student?.id ?? null, view: effectiveView, setView, setStudentId, canPick: (me.data?.students.length ?? 0) > 1 };
}
